const state = {
  sysToken: '', //  Token
  sysUid: '', //  Uid
  isLogin: false, //  是否登录
  verName: 'verName',
  userInfo: {}, //  登录账号信息
  companyInfo: {}, //  公司信息
  originCompanyInfo: {}, //  原始公司信息
  isGSLogin: false, //  是否是公司账号登录
  originNavList: [], //  权限原始数据
  navList: [], //  权限列表
  brandList: [], //  品牌列表
  shopList: [], //  门店列表
  brandInfo: {}, //  当前品牌信息
  shopInfo: {}, //  当前门店信息
  allShopList: [], // 所有门店，包括门店，供应商，仓库
  backMenuConfig: [], // 后台菜单配置(json数组)
  backPageConfig: [], // 后台菜单配置(json数组)
  frontPageConfig: [], // 前台页面配置(json数组)
  agentCompanyList: [], // 代理公司列表
  groupInfo: {}, // 当前集团信息
  companyAccountList: [],
  customChargeItemList: [] // 高校门店其他费用
}
export default state
